export default __webpack_public_path__ + "static/video2-a4d0c3b5814f1f0512bd8c442dedb606.webp";